export const boldHeaderStyle = {
    fontWeight: 'bold',
    borderRight: '1px solid #e0e0e0', // Add border right to header cells
};

export const cellStyle = {
    borderRight: '1px solid #e0e0e0', // Add border right to other cells
};

export const downloadButtonStyle = {
    backgroundColor: '#f9f9f9',  // Solid muted blue color
    border: 'none', // Remove border
    borderRadius: '5px', // Rounded corners
    padding: '6px 12px', // Padding to make the button a bit larger
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', // Subtle shadow
    color: 'black', // White text color
    fontSize: '0.875rem', // A bit larger font size
    transition: '0.3s', // Transition effect for smooth hover effect

    '&:hover': {
        backgroundColor: '#ced4da', // Slightly darker blue on hover
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Increased shadow on hover
    },
};